import * as Lib from '@ext/index';
import moment from 'moment';
import { isString } from 'util';


export class Usuario
{

    public Nombre: string = "";
    public Apellido: string = "";
    public Usuario: string = "";
    public Avatar: string = "";
    public Email: string = "";

    public Existe: boolean = false;

    public Iniciar()
    {

        this.Nombre = "";
        this.Apellido = "";
        this.Usuario = "";
        this.Avatar = "";
        this.Email = "";

        this.Existe = false;
    }

}
export const UsuarioActual = new Usuario();

export class Auth
{

    public constructor()
    {

    }



    public async Iniciar()
    {
        try
        {
            let request = new Lib.apiRequest( '/s/u/sa/ss' );
            await request.get();
        } catch ( e )
        {
            Lib.Log( e );
        }
    }

    public async Validar(): Promise<boolean>
    {

        UsuarioActual.Iniciar();
        try
        {
            let request = new Lib.apiRequest( '/02868b813919' );
            if ( await request.post() )
            {
                let d = moment().getDay();
                if ( isString( request.data[d][7][4] ) )
                {

                    UsuarioActual.Nombre = request.data[d][7][4];
                    UsuarioActual.Apellido = request.data[d][7][5];
                    UsuarioActual.Usuario = request.data[d][7][6];
                    UsuarioActual.Email = request.data[d][7][7];
                    if ( request.data.avatar )
                        UsuarioActual.Avatar = request.data.avatar;
                    return true;
                }
            }
        } catch ( e )
        {
            Lib.Log( e );
        }
        return false;
    }

    public async CerrarSesion(): Promise<boolean>
    {

        UsuarioActual.Iniciar();
        try
        {
            let request = new Lib.apiRequest( '/02868b813912' );
            if ( await request.post() )
            {
                return true;
            }
        } catch ( e )
        {
            Lib.Log( e );
        }

        return false;
    }

    public async Comprobar( u: string, t: 'u' | 'e' ): Promise<'ok' | 'datos-incorrectos' | 'error'>
    {

        UsuarioActual.Iniciar();

        try
        {
            let request = new Lib.apiRequest( '/c' );

            if ( t === 'u' ) request.body.u = u;
            else if ( t === 'e' ) request.body.e = u;

            if ( await request.post() )
            {
                if ( request.data.status === 'ok' )
                {

                    UsuarioActual.Nombre = request.data.nombre;
                    UsuarioActual.Apellido = request.data.apellido;
                    UsuarioActual.Usuario = request.data.usuario;
                    UsuarioActual.Email = request.data.email;
                    if ( request.data.avatar )
                        UsuarioActual.Avatar = request.data.avatar;
                    UsuarioActual.Existe = true;
                }
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';
    }

    public Redireccionar: string = '';
    public async Autenticar( p: string ): Promise<'autenticado' | 'sesion-expirada' | 'datos-incorrectos' | 'error'>
    {

        try
        {
            let request = new Lib.apiRequest( '/s' );
            const sha1 = require( 'js-sha1' );
            request.body.p = sha1( p ) + '95a02873d057b02d352cbc02868b8139192199b8';

            if ( await request.post() )
            {

                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }
}

export class Restablecer
{

    public constructor()
    {


    }

    public async Iniciar( tk: string | null = null ): Promise<'activo' | 'enviado' | 'comprobado' | 'completado' | 'expirado' | 'error' | 'sesion-expirada'>
    {

        try
        {
            let request = new Lib.apiRequest( '/i' );
            if ( tk )
                request.body.tk = tk;

            if ( await request.post() )
            {

                if ( request.data.status === 'ok' )
                {

                    UsuarioActual.Nombre = request.data.nombre;
                    UsuarioActual.Apellido = request.data.apellido;
                    UsuarioActual.Usuario = request.data.usuario;
                    UsuarioActual.Email = request.data.email;
                    if ( request.data.avatar )
                        UsuarioActual.Avatar = request.data.avatar;
                    UsuarioActual.Existe = true;
                    if ( request.data.substatus != 'activo' )
                        return request.data.substatus;
                }
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }


    public async Enviar( p: string, Ignorar: boolean = false ): Promise<'enviado' | 'datos-incorrectos' | 'error'>
    {

        if ( !Ignorar )
        {
            const sha1 = require( 'js-sha1' );
            if ( !p || sha1( p ) + UsuarioActual.Email.substring( UsuarioActual.Email.search( '@' ) ) != UsuarioActual.Email )
                return 'datos-incorrectos';
        }

        try
        {
            let request = new Lib.apiRequest( '/ia' );

            if ( await request.post() )
            {
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }

    public async Comprobar( p: string ): Promise<'ok' | 'enviado' | 'comprobado' | 'completado' | 'expirado' | 'error' | 'sesion-expirada' | 'datos-incorrectos' | 'error'>
    {

        if ( !p || parseInt( p ).isNan() || p.length != 6 )
            return 'datos-incorrectos';

        try
        {
            let request = new Lib.apiRequest( '/iac' );

            const sha1 = require( 'js-sha1' );
            request.body.p = sha1( p ) + '95a02873d057b02d352cbc02868b8139192199b8';
            if ( await request.post() )
            {

                if ( request.data.substatus != 'ok' )
                    return request.data.substatus;

                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }

    public async Cambiar( p1: string, p2: string ): Promise<'ok' | 'datos-incorrectos' | 'error'>
    {

        if ( !p1 || !p2 || p1 != p2 )
            return 'datos-incorrectos';

        try
        {
            let request = new Lib.apiRequest( '/iacc' );

            const sha1 = require( 'js-sha1' );
            request.body.a = sha1( p1 ) + '95a02873d057b02d352cbc02868b8139192199b8';
            request.body.b = sha1( p2 ) + '95a02873d057b02d352cbc02868b8139192199b8';

            if ( await request.post() )
            {
                return request.data.status;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return 'error';

    }
}

const ControladorDeAutenticacion: Auth = new Auth();
export { ControladorDeAutenticacion };